import { type FC, memo } from 'react';

import { translations } from './SelectLanguage';

import './QuitGamePopup.css';


interface QuitGamePopUpProps {
    onContinuClick: ()=> void;
    onQuitClick: ()=> void;
}

export const QuitGamePopUp: FC<QuitGamePopUpProps> = memo(({ onContinuClick, onQuitClick }) => {
    const handleContinueClick = () => {
        onContinuClick();
    }
    const handleQuitClick = () => {
        onQuitClick();
    }
    return (
        <div className="areYouSurePopUp">
            <div className="areYouSureText">{translations.areYouSure}</div>
            <div className="quitGameButtonContainer">
                <button 
                    className="quitGameButton"
                    onClick={handleQuitClick}
                >
                    {translations.yes}
                </button>
                <button 
                    className="quitGameButton"
                    style={{background: "#1ddb24"}}
                    onClick={handleContinueClick}
                >
                    {translations.continue}
                </button>
            </div>
        </div>
    );
});
